module.exports = __webpack_public_path__ + "img/bg_og.ee9ef9c6.jpg";